import { UserCircleIcon } from '@phosphor-icons/react/dist/csr/UserCircle';
import clsx from 'clsx';

export const PriorityBadge = ({
  isPriority = false,
}: {
  isPriority?: boolean;
}) => {
  const iconColor = isPriority
    ? 'text-(--priority-dark) shadow-[0px_1px_1px_0px_rgba(255,255,255,0.32)]'
    : 'ds-text-dataviz-gray';
  const textColor = isPriority
    ? 'text-(--priority-dark) [text-shadow:0px_1px_1px_rgb(255_255_255/0.32)]'
    : 'ds-text-dataviz-gray';
  const borderColor = isPriority
    ? 'p-px -m-px rounded-full bg-[linear-gradient(to_bottom,var(--priority-border-yellow),var(--priority-border-orange))]'
    : '';
  const bgColor = isPriority
    ? 'bg-[linear-gradient(to_bottom,var(--priority-bg-yellow),var(--priority-bg-orange))] shadow-[inset_0px_2px_1px_0px_rgba(255,255,255,0.32)]'
    : 'bg-neutral-100';

  return (
    <>
      <div className={clsx('rounded-full', borderColor)}>
        <div
          className={`h-7 py-1 pl-1 pr-3 ${bgColor} rounded-full flex justify-center items-center gap-1 relative overflow-hidden isolate transform-gpu [-webkit-mask-image:-webkit-radial-gradient(white,black)] mask-[radial-gradient(white,black)]`}
        >
          <div className="w-5 h-5 relative overflow-hidden">
            <UserCircleIcon size={20} className={iconColor} weight="fill" />
          </div>

          <div
            className={`${textColor} font-extrabold text-[11px] tracking-widest`}
          >
            {isPriority ? 'PRIORITY' : 'STANDARD'}
          </div>

          {isPriority && (
            <div
              className="absolute pointer-events-none"
              style={{
                width: '17px',
                height: '86px',
                bottom: '-24.416px',
                background: 'rgba(255, 255, 255, 0.24)',
                mixBlendMode: 'plus-lighter',
                filter: 'blur(6px)',
                animation: `shimmer-slide-text 1.1s linear both`,
                animationDelay: '200ms',
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};
